import { getInstance } from "../../core/axios-gateway";
import { TRestListData, TRestListParams } from "../../types/rest";
import {
  TListedTicket,
  TRefundType,
  TTicketDetail,
  TTicketForm,
  TTicketPayload,
  TTicketProduct,
  TTicketReason,
  TTicketResponse,
  TTicketType,
} from "../../types/ticket";

const BASE_PATH = "/api/tickets";

export const getTickets = async (params: TRestListParams) => {
  return getInstance()
    .get<TRestListData<TListedTicket>>(BASE_PATH, {
      params,
    })
    .then((res) => res.data);
};

export const getTicketsBySellerId = async (
  sellerId: string,
  params: TRestListParams
) => {
  return getInstance()
    .get<TRestListData<TListedTicket>>(
      `${BASE_PATH}/?search=userId:${sellerId}`,
      {
        params,
      }
    )
    .then((res) => res.data);
};

export const getTicketsTypes = async () => {
  return getInstance()
    .get<TTicketType[]>(`${BASE_PATH}/ticketTypes`)
    .then((res) => res.data);
};

export const createTicket = async (data: TTicketPayload) => {
  return getInstance()
    .post<TTicketPayload>(`${BASE_PATH}`, data)
    .then((res) => res.data);
};

export const getTicketById = async (ticketId: string) => {
  return getInstance()
    .get<TTicketDetail>(`${BASE_PATH}/id/${ticketId}`)
    .then((res) => res.data);
};

export const getProductsBySubpurchaseId = async (subpurchaseId: string) => {
  return getInstance()
    .get<TTicketProduct[]>(
      `${BASE_PATH}/available-products-quantities/${subpurchaseId}`
    )
    .then((res) => res.data);
};

export const answerTicket = async (ticketId: string, data: TTicketResponse) => {
  return getInstance()
    .put<TTicketDetail>(`${BASE_PATH}/id/${ticketId}`, data)
    .then((res) => res.data);
};

export const updateTicket = async (
  ticketId: string,
  data: Partial<TTicketDetail>
) => {
  return getInstance()
    .put<TTicketDetail>(`${BASE_PATH}/id/${ticketId}`, data)
    .then((res) => res.data);
};

export const getTicketReasons = async (purchaseId: string) => {
  return getInstance()
    .get<TTicketReason[]>(`${BASE_PATH}/ticket-reasons/${purchaseId}`)
    .then((res) => res.data);
};

export const getTicketFormByReason = async (
  reasonCode: string,
  purchaseId: string
) => {
  return getInstance()
    .get<TTicketForm>(
      `${BASE_PATH}/info-creation-by-reason/${reasonCode}/${purchaseId}`
    )
    .then((res) => res.data);
};

export const getRefundTypes = (purchaseId: string) => {
  return getInstance()
    .get<TRefundType[]>(`${BASE_PATH}/refund-types/${purchaseId}`)
    .then((res) => res.data);
};
